import _ from 'lodash';
import * as actionTypes from 'constants/ActionTypes';

const cargoDuplicates = (state = {
    items: [],
    isLoaded: false,
    searchText: '',
}, action) => {
    switch (action.type) {
    case actionTypes.GET_CARGO_DUPLICATES.REQUEST:
        return {
            ...state,
            isLoaded: false,
        };
    case actionTypes.GET_CARGO_DUPLICATES.SUCCESS:
        const items = action.data.map((item) => {
            return {
                ...item,
                errors: [],
            }
        });

        return {
            ...state,
            isLoaded: true,
            items,
        };
    case actionTypes.GET_CARGO_DUPLICATES.FAILURE:
        return {
            ...state
        };

    case actionTypes.DELETE_CARGO_DUPLICATE.REQUEST:
        return {
            ...state,
        };
    case actionTypes.DELETE_CARGO_DUPLICATE.SUCCESS: {
        let entities = [];

        const findItem = state.items.find((item, i) => {
            const stateItem = item;

            if (stateItem._id === action.item.name) {
                stateItem.index = i;
                return stateItem;
            }

            return false;
        });

        if (findItem.entities.length === 1 || findItem.entities.length === 2) {
            state.items.splice(findItem.index, 1);
            return {
                ...state,
                items: state.items.slice(),
            };
        }

        if (findItem.entities.length > 2) {
            entities = findItem.entities.filter(entity => entity._id !== action.item.id);

            state.items[findItem.index].entities = entities;

            return {
                ...state,
                items: state.items.slice(),
            };
        }

        return {
            ...state,
        };
    }
    case actionTypes.DELETE_CARGO_DUPLICATE.FAILURE: {
        const items = state.items.map((item) => {
            if (action.item.name === item._id) {
                return {
                    ...item,
                    errors: action.errors,
                }
            }
            return item;
        });

        return {
            ...state,
            items,
        };
    }

    case actionTypes.SEARCH_CARGO_DUPLICATES:
        return {
            ...state,
            searchText: action.search,
        };

    case actionTypes.CLEAR_DUPLICATES:
        return {
            ...state,
            items: [],
            isLoaded: false,
        };
    default:
        return state;
    }
};

export default cargoDuplicates;



// WEBPACK FOOTER //
// ./app/reducers/cargoes/duplicates.js